module.exports = __webpack_public_path__ + "static/media/user.c512e3bd.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/icons/user.svg
// module id = 505
// module chunks = 98